<script setup lang="ts">
import MemberHeader from "@/components/member/MemberHeader.vue";
import DeveloperSidebar from "@/components/developer/DeveloperSidebar.vue";

const notifications = [
  { id: 1, type: 'alert', icon: 'fa-exclamation-triangle', color: 'text-error', bg: 'bg-red-50 border-red-200', title: 'Clarification Required – Mangrove Project', body: 'SGS Carbon Services has requested clarification on your FPIC documentation for Zone 3.', date: '2025-04-15 09:14', read: false, action: 'View Verification Status' },
  { id: 2, type: 'info', icon: 'fa-info-circle', color: 'text-blue-500', bg: 'bg-blue-50 border-blue-200', title: 'Monitoring Report Due', body: 'Your Period 2 monitoring report for Solar Park Beta is due by 30 June 2025.', date: '2025-04-10 08:00', read: false, action: 'Upload Reports' },
  { id: 3, type: 'success', icon: 'fa-check-circle', color: 'text-green-500', bg: 'bg-green-50 border-green-200', title: 'Verification Approved – Solar Park Beta Period 1', body: 'Bureau Veritas has approved your Period 1 verification. You may now request credit issuance.', date: '2024-11-20 14:32', read: true, action: 'Request Credits' },
  { id: 4, type: 'success', icon: 'fa-award', color: 'text-green-500', bg: 'bg-green-50 border-green-200', title: 'Registration Certificate Issued', body: 'Your Project Registration Certificate (CR-2024-00089) has been issued for Solar Park Beta.', date: '2024-03-15 11:00', read: true, action: 'View Certificate' },
  { id: 5, type: 'info', icon: 'fa-stamp', color: 'text-blue-500', bg: 'bg-blue-50 border-blue-200', title: 'LoA Received from DNA', body: 'The National Climate Change Authority (Kenya) has issued your Letter of Authorization for Solar Park Beta.', date: '2024-02-28 10:15', read: true, action: 'View LoA Status' },
  { id: 6, type: 'info', icon: 'fa-bell', color: 'text-gray-400', bg: 'bg-gray-50 border-gray-200', title: 'System Maintenance', body: 'The registry will be unavailable on 25 April 2025 from 02:00–04:00 UTC for scheduled maintenance.', date: '2025-04-08 07:00', read: true, action: null },
]
</script>

<template>
  <MemberHeader />

  <div class="flex h-screen bg-gray-50">
    <DeveloperSidebar />

    <main class="flex-1 overflow-auto py-8">
      <div class="max-w-4xl mx-auto px-5">

        <section class="mb-8">
          <div class="bg-white rounded-lg border border-gray-200 p-6">
            <div class="flex items-start justify-between">
              <div>
                <h1 class="text-3xl font-bold text-accent mb-2">Notifications</h1>
                <p class="text-gray-600">All messages from the registry, DOEs, and government authorities.</p>
              </div>
              <div class="flex items-center space-x-2">
                <button class="text-sm text-primary hover:underline">Mark all as read</button>
                <span class="text-gray-300">|</span>
                <span class="bg-error text-white text-xs rounded-full px-2 py-0.5">2 unread</span>
              </div>
            </div>
          </div>
        </section>

        <!-- Filter tabs -->
        <div class="flex space-x-1 border-b border-gray-200 mb-6">
          <button class="px-4 py-2 text-sm font-medium text-primary border-b-2 border-primary">All</button>
          <button class="px-4 py-2 text-sm text-gray-600 hover:text-gray-800">Alerts</button>
          <button class="px-4 py-2 text-sm text-gray-600 hover:text-gray-800">Updates</button>
          <button class="px-4 py-2 text-sm text-gray-600 hover:text-gray-800">System</button>
        </div>

        <div class="space-y-3">
          <div
            v-for="n in notifications"
            :key="n.id"
            :class="['border rounded-lg p-4 flex items-start space-x-4', n.bg, n.read ? 'opacity-75' : '']"
          >
            <div class="flex-shrink-0 mt-0.5">
              <i :class="['fas text-lg', n.icon, n.color]"></i>
            </div>
            <div class="flex-1">
              <div class="flex items-start justify-between">
                <p :class="['text-sm font-medium', n.read ? 'text-gray-700' : 'text-gray-900']">
                  {{ n.title }}
                  <span v-if="!n.read" class="ml-2 bg-primary text-white text-xs rounded-full px-1.5 py-0.5">New</span>
                </p>
                <span class="text-xs text-gray-400 flex-shrink-0 ml-3">{{ n.date }}</span>
              </div>
              <p class="text-sm text-gray-600 mt-0.5">{{ n.body }}</p>
              <button v-if="n.action" class="text-xs text-primary hover:underline mt-1">
                {{ n.action }} <i class="fas fa-arrow-right ml-0.5 text-xs"></i>
              </button>
            </div>
          </div>
        </div>

      </div>
    </main>
  </div>
</template>
